import _regeneratorRuntime from "/builds/sites/europa-fm-pwa/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* eslint-disable no-underscore-dangle */
// This script is a callback for CMP core Listeners
// Reads IAB consents and sets the corresponding Google consents


import { CONSENTS_INTERFACE } from './consentUtils';
var googleVendorsUrl = 'https://static.antena3.com/js/cmp/googleVendors.json';

var googleConsent = _objectSpread({}, CONSENTS_INTERFACE.google);

var fetchGoogleVendors = function fetchGoogleVendors() {
  return fetch(googleVendorsUrl).then(function (res) {
    return res.json();
  }).then(function (googleVendors) {
    return googleVendors;
  });
};

export default /*#__PURE__*/(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(otherVendorConsents, googleSuccess) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!googleSuccess) {
              _context.next = 9;
              break;
            }

            googleConsent.associatedTechnologies = Boolean(Number(otherVendorConsents.googleConsent));

            if (!googleConsent.associatedTechnologies) {
              _context.next = 8;
              break;
            }

            _context.next = 5;
            return fetchGoogleVendors();

          case 5:
            googleConsent.associatedIds = _context.sent;
            _context.next = 9;
            break;

          case 8:
            googleConsent.associatedIds = [];

          case 9:
            window.consents = _objectSpread(_objectSpread({}, window.consents), {}, {
              google: googleConsent
            });

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
})();